import { Phone } from 'lucide-react'
import { aboutPage } from '../../data/about'
import { getAboutJsonLd } from '../../lib/seo'
import { siteConfig } from '../../lib/site-config'
import { PageShell } from '../layout/page-shell'
import { PageTitle } from '../seo/page-title'
import { ButtonLink } from '../ui/button'

export interface AboutPageProps {}

export function AboutPage(_: Readonly<AboutPageProps>) {
  const jsonLd = getAboutJsonLd()

  return (
    <PageShell>
      <PageTitle title="About Lyle Patterson | Autoglow Detailing" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <section className="packages-hero">
        <img
          src="/images/lyle-studio.jpg"
          alt="Lyle working in the Autoglow Detailing studio."
          width="2560"
          height="1440"
        />
        <div className="packages-hero-content">
          <p className="eyebrow">{aboutPage.eyebrow}</p>
          <h1>{aboutPage.title}</h1>
          <p>{aboutPage.intro}</p>
          <div>
            <ButtonLink href="/contact">Contact the studio</ButtonLink>
            <ButtonLink href="/ceramic-protection" variant="ghost">Ceramic Protection</ButtonLink>
          </div>
        </div>
      </section>

      <section className="studio-section" aria-labelledby="about-lyle-heading">
        <div className="section-container studio-grid">
          <div className="studio-media">
            <img
              src="/images/lyle-studio.jpg"
              alt="Lyle Patterson in the Autoglow studio."
              width="900"
              height="900"
              loading="lazy"
            />
            <div className="experience-tile">
              <strong>18+</strong>
              <span>Years Experience</span>
            </div>
          </div>
          <div className="studio-copy">
            <p className="eyebrow">The Studio</p>
            <h2 id="about-lyle-heading">GYEON certified, Bellarine based</h2>
            {aboutPage.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            <p className="studio-quote">“{aboutPage.quote}”</p>
            <div className="direct-line">
              <span>Direct Line</span>
              <a href={`tel:${siteConfig.phone.split(' ').join('')}`}>
                <Phone size={20} /> {siteConfig.phone}
              </a>
              <p>Contact Lyle directly for specialist assessments.</p>
            </div>
          </div>
        </div>
      </section>
    </PageShell>
  )
}

export default AboutPage
